import { render, staticRenderFns } from "./LoadPage.vue?vue&type=template&id=30276ed3&scoped=true&"
import script from "./LoadPage.vue?vue&type=script&lang=js&"
export * from "./LoadPage.vue?vue&type=script&lang=js&"
import style0 from "./LoadPage.vue?vue&type=style&index=0&id=30276ed3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30276ed3",
  null
  
)

export default component.exports